/* Componentes do Angular */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

/* Services */
import { IbgeService } from '../../services/ibge.service';

/* Externos */
import { Util } from '../../utils/util';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'pais',
    templateUrl: './pais.component.html',
    styleUrls: ['./pais.component.scss']
})

export class PaisFormComponentComponent implements OnInit {
    public countryList: any;

    @Input() group: FormGroup;
    @Input() obrigatorio = false;

    // Output para informar que a lista está carregada
    @Output() countriesListLoadedEvent = new EventEmitter();

    MSG_CAMPO_OBRIGATORIO = Util.getMensagemCampoObrigatorio();

    constructor(
        private ibgeService: IbgeService
    ) { }

    ngOnInit() {
        this.loadCountries();
    }

    private loadCountries() {
        this.ibgeService.getListPaises()
            .subscribe(paises => {
                this.countryList = Util.orderBy(paises, 'Nome');
                this.group.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').setValue(Util.getAlphaCodeBrazil());
                this.group.get('Endereco.Municipio.UF.Pais.CodigoAlpha3').markAsTouched();
                this.countriesListLoadedEvent.emit(); // Avisa que a lista está pronta pra uso
            });
    }

    // Método necessário para setar o nome do Pais quando mudar a opção selecionada
    onChangePais(codigoAlpha3) {
        if (!!this.group.get('Endereco.Municipio.UF.Pais.Nome') && this.countryList) {
            const paisSelecionado = this.countryList.find(x => x.CodigoAlpha3 === codigoAlpha3);

            if (paisSelecionado) {
                this.group.get('Endereco.Municipio.UF.Pais.Nome').setValue(paisSelecionado.Nome);
            }
        }
    }
}
